<template>
    <div class="course-mytask">
        <div class="content-collect">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                                v-model="loading"
                                :finished="finished"
                                finished-text="没有更多了"
                                :immediate-check="false"
                                @load="getMyWorkEvent"
                                class="content-collect"
                        >
                    <div class="task-li"  v-for="(item,index) in list" :key="index" >
                        <div class="task-work-name">
                            <div style="flex:1;margin-left: 5px;" @click="bindTaskClick(item)" >{{item.name}}</div>
                            <div class="task-work-icon">
                                <span class="iconfont iconxinaixin"></span>
                                <span style="margin-left: 5px;">{{item.favor_cnt}}</span>
                                <span class="iconfont iconxiaoxi2"></span>
                                <span style="margin-left: 5px;">{{item.replys_cnt}}</span>
                            </div>
                        </div>
                        <div style="margin:10px 0">
                            <div>
                                <div  v-if="item.content.length > 80" >
                                    <span v-if="item.open_text == 1" >{{item.content.substring(0,80)+'...'}}</span>
                                    <span v-if="item.open_text == 2" >{{item.content}}</span>
                                    <span class="toggleTaskText" style="color: #4395ff;" data-type="2" :data-index="index"  @click="toggleTaskText" v-if="item.open_text == 1" >展开</span>
                                    <span class="toggleTaskText" style="color: #4395ff;" data-type="1" :data-index="index"  @click="toggleTaskText" v-if="item.open_text == 2" >收起</span>
                                </div>
                                <div v-else >{{item.content}}</div>
                                
                            </div>
                        </div>
                        <div class="task-work-course">
                            <div class="work-course-name" @click="bindCourseClick(item)" >{{item.course_name}}</div>
                            <div class="work-course-time">{{item.create_time_cn}}</div>
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>
<script>
    import { List,PullRefresh  } from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List,
            [PullRefresh .name]:PullRefresh
        },
        data(){
            return {
                total:0,
                page:1,
                pageSize:14,
                list:[],
                loading: false,
                finished: false,
                refreshing: false,
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.getMyWorkEvent(1);
        },
        methods:{
            bindCourseClick:function(item){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?&course_id='+item.course_id+'&token='+this.util.token);
            },
            bindTaskClick:function(item){
                this.$router.push(this.util.urlPrefix+'/curriculum/index?&course_id='+item.course_id+'&work_busy_id='+item.work_busy_id+'&token='+this.util.token);
            },
            onRefresh() {
                this.getMyWorkEvent(1);
            },
            getMyWorkEvent(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo

                }else{

                    this.page=page

                }
                this.util.server.mini_work.my_answer_work({
                    data:{
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(this.refreshing){
                            this.refreshing=false;
                        }
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total = data.total;
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {
                                let templist = [];
                                if(page == 1){
                                    templist = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    templist = this.list.concat(data.items);
                                }
                                for(var i=0;i<templist.length;i++){
                                    templist[i].open_text = 1;
                                }
                                this.list = templist

                                //判断是否存在下一页
                                this.loading = false;

                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
            toggleTaskText(e){
                const data_index = e.target.getAttribute('data-index')
                const data_type = e.target.getAttribute('data-type')
                this.$set(this.list[data_index], `open_text`, data_type)
            }
        }
    }
</script>
<style  scoped>

.task-li{
    padding: 10px;
    border-bottom: 2px solid #eee;
    /*border-bottom: 1px dashed #ccc;*/
}
.task-li-work{
    position: relative;
}
.task-li-work .work-name{
    padding-right: 117px;
    font-size: 12px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
    height: 32px;
}
.task-li-work .work-txt{
    position: absolute;
    right: 0;
    top: 0;
}
.task-li .task-work-name{
    font-weight: bold;
    display: flex;
}
.task-work-name .task-work-icon{
    font-size: 12px;
}
.task-work-name .task-work-icon .iconxinaixin{
    color: #de350b;
    font-size: 12px;
}
.task-work-name .task-work-icon .iconxiaoxi2{
    color: #327CE9;
    font-size: 14px;
    margin-left: 20px;
}

.task-li .task-work-content{
    /*margin: 10px 0;*/
    /*line-height: 22px;*/
}
.task-li .task-work-course{
    display: flex;
}
.task-li .task-work-course .work-course-name {
    font-size: 12px;
    color: #999;
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 10px;
}
.task-li .task-work-course .work-course-time{
    font-size: 12px;
    color: #999;
}
.toggleTaskText{
    cursor: pointer;
}
</style>